import { AbstractObjectsValidator } from "./AbstractObjectsValidator";
import { IFormatObjectEditable } from "..";
import { IFormatAlert } from "../IFormatAlert";
import { ElementTypes } from "../objects";
import { IObjectValidator } from "../IObjectValidator";
import { RollObjectValidator } from "./RollObjectValidator";
import { ComboObjectValidator } from "./ComboObjectValidator";
import { CalculateObjectValidator } from "./CalculateObjectValidator";
import { BarcodeObjectValidator } from "./BarcodeObjectValidator";
import { JoinTextObjectValidator } from "./JoinTextObjectValidator";
import { GraphObjectValidator } from "./GraphObjectValidator";
import { ScriptObjectValidator } from "./ScriptObjectValidator";
import { ScriptLinkObjectValidator } from "./ScriptLinkObjectValidator";
import { CheckObjectValidator } from "./CheckObjectValidator";
import { CircleSelectObjectValidator } from "./CircleSelectObjectValidator";
import { DateObjectValidator } from "./DateObjectValidator";
import { TextObjectValidator } from "./TextObjectValidator";
import { TagObjectValidator } from "./TagObjectValidator";

export class ObjectValidator extends AbstractObjectsValidator {
  private _validators: { [key in ElementTypes]: IObjectValidator; } = {
    text: new TextObjectValidator(),
    date: new DateObjectValidator(),
    tag: new TagObjectValidator(),
    script: new ScriptObjectValidator(),
    scriptlink: new ScriptLinkObjectValidator(),
    calculate: new CalculateObjectValidator(),
    jointext: new JoinTextObjectValidator(),
    check: new CheckObjectValidator(),
    circleselect: new CircleSelectObjectValidator(),
    combo: new ComboObjectValidator(),
    roll: new RollObjectValidator(),
    imagearea: null,
    image: null,
    stamp: null,
    graph: new GraphObjectValidator(),
    embed: null,
    sign: null,
    barcode: new BarcodeObjectValidator(),
    poscorrect: null,
    richText: null,
    newPage: null,
    watermark: null,
    variablearea: null,
    line: null,
    boxline: null,
    circle: null,
    triangle: null,
    cross: null,
  };

  protected validateObject(object: IFormatObjectEditable): IFormatAlert[] {
    const validator = this._validators[object.objectTypeName().getValue()];
    if (!validator) { return; }
    return validator.validate(object);
  }
}
